import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a726acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status-parameter_name" }
const _hoisted_2 = {
  key: 1,
  class: "status-parameter_input-block"
}
const _hoisted_3 = {
  key: 2,
  class: "status-parameter_color-change"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-parameter_divider" }, null, -1))

import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmColorPalette,
  TirPmInput,
} from "tir-components";
import { CheckIcon, CrossCompactIcon } from "tir-style-system/icons/outline";
import { computed, PropType, ref, watch } from "vue";
import { TaskParameterTypeEnum } from "../enums";
import { getTaskParameterPalette } from "../services";
import { TaskParameterModel } from "../models";
import { PaintIcon } from "tir-style-system/icons/solid";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'status-parameter',
  props: {
  /**Скрыть удаление */
  hideRemove: { type: Boolean },
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Данные о настройке */
  data: { type: Object as PropType<TaskParameterModel>, default: () => new TaskParameterModel() },
  /**Демонстрационный тег */
  preview: { type: Boolean, default: false },
},
  emits: ["remove"],
  setup(__props, { emit }) {

const props = __props;



/**События */


/**Сфокусирован ли какой то параметр */
const isFocus = ref();

const isHover = ref(false);

const isEditing = ref(false);

const newNameStatus = ref();

const editingStatus = (value) => {
  if (!props.preview) isEditing.value = value;
};

/**Имя статуса */
const statusName = computed(() => props.data.Name?.toLocaleUpperCase() || "");

/**Цвет текста */
const textColor = computed(() => ({ color: props.data.Color }));
/**Сменить цвет параметра */
const changeParameterColor = (parameter: TaskParameterModel, color: string) => {
  parameter.Color = color;
};

/**Есть фокус на поле ввода или открыто окно выбора цвета */
const setFocus = (_isFocus: boolean) => {
  isFocus.value = _isFocus;
};

/**Смена имени параметра */
const changeName = (parameter: TaskParameterModel, name: string | number) => {
  parameter.Name = String(name);
  isEditing.value = false;
};

const setHover = (_isHover) => {
  isHover.value = isEditing.value ? false : _isHover;
};

const setNameStatus = (value) => {
  newNameStatus.value = value;
};

/**Цвет фона */
const backgroundColor = computed(() => ({ "background-color": props.data.Color + "1A" }));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onMouseenter: _cache[16] || (_cache[16] = ($event: any) => (setHover(true))),
    onMouseleave: _cache[17] || (_cache[17] = ($event: any) => (setHover(false))),
    class: "status-parameter",
    style: _normalizeStyle(backgroundColor.value)
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({ background: props.data.Color }),
      class: "status-parameter_circle"
    }, null, 4),
    _createElementVNode("div", _hoisted_1, [
      (!isEditing.value)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            onDblclick: _cache[0] || (_cache[0] = ($event: any) => (editingStatus(true))),
            style: _normalizeStyle({ color: props.data.Color })
          }, _toDisplayString(statusName.value), 37))
        : _createCommentVNode("", true),
      (isEditing.value && !__props.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(TirPmInput), {
              class: "status-parameter_input",
              color: props.data.Color,
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (editingStatus(true))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (editingStatus(false))),
              onKeyup: [
                _cache[3] || (_cache[3] = _withKeys(($event: any) => (
            changeName(props.data, newNameStatus.value ?? props.data.Name), editingStatus(false)
          ), ["enter"])),
                _cache[4] || (_cache[4] = _withKeys(($event: any) => (editingStatus(false)), ["esc"]))
              ],
              modelValue: statusName.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((statusName).value = $event)),
              onInput: _cache[6] || (_cache[6] = ($event: any) => (setNameStatus($event))),
              isMicro: "",
              autoFocus: ""
            }, null, 8, ["color", "modelValue"]),
            _createElementVNode("div", {
              style: _normalizeStyle({ background: textColor.value.color }),
              class: "status-parameter_divider"
            }, null, 4),
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Small,
              onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (changeName(props.data, newNameStatus.value ?? props.data.Name)), ["stop"])),
              class: "status-parameter_icon"
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(CheckIcon), { class: "status-parameter_icon" })
              ]),
              _: 1
            }, 8, ["variant", "size"]),
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Small,
              onMousedown: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (editingStatus(false)), ["stop"])),
              class: "status-parameter_icon"
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(CrossCompactIcon), { class: "status-parameter_icon" })
              ]),
              _: 1
            }, 8, ["variant", "size"])
          ]))
        : _createCommentVNode("", true),
      ((isHover.value || isFocus.value) && !__props.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              style: _normalizeStyle({ background: textColor.value.color }),
              class: "status-parameter_divider"
            }, null, 4),
            _createVNode(_unref(TirPmColorPalette), {
              class: "status-parameter_color",
              "model-value": props.data.Color,
              position: _unref(PopoverPositionEnum).Bottom,
              colors: _unref(getTaskParameterPalette)(__props.type),
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (changeParameterColor(props.data, $event))),
              onOpen: _cache[13] || (_cache[13] = ($event: any) => (setFocus(true))),
              onClose: _cache[14] || (_cache[14] = ($event: any) => (setFocus(false)))
            }, {
              icon: _withCtx((slot) => [
                _createElementVNode("div", {
                  class: "status-parameter_color",
                  onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createVNode(_unref(PaintIcon), {
                    style: _normalizeStyle({ color: slot.color })
                  }, null, 8, ["style"])
                ], 32)
              ]),
              _: 1
            }, 8, ["model-value", "position", "colors"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!__props.hideRemove)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_4,
          _createElementVNode("div", {
            class: "status-parameter_delete",
            onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (emit('remove')), ["stop"]))
          }, [
            _createVNode(_unref(CrossCompactIcon))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 36))
}
}

})